import { useTranslation } from "react-i18next";
import React from "react";
import { toast } from "react-toastify";
import useAppDispatch from "../../../../../../hooks/redux/base/useAppDispatch";
import { ConfirmDialog } from "@duosoftbg/nacid-components";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { deleteServiceDefinition } from "../../../../../../axios/api/services";
import { closeModal } from "../../../../../../store/redux/slice/ComponentsControl/serviceDefinitionControl";
import useViewDataObject from "../../../../../../hooks/redux/useViewDataObject";
import { VIEW_TYPES } from "../../../../../../config/view/types";
import { addViewObject } from "../../../../../../store/redux/slice/ViewData/viewDataPage";

const ServiceDefinitionDeleteDialog = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { data: serviceDefinitionsViewData } = useViewDataObject(VIEW_TYPES.SERVICE_DEFINITION_EDIT);

  const { open, id } = useAppSelector((state) => {
    return state.ComponentsControl.serviceDefinitionControl.modals.delete;
  });

  const handleCloseDialog = () => {
    dispatch(closeModal({ modalType: "delete" }));
  };

  const onSuccess = () => {
    const definitions = serviceDefinitionsViewData.filter((definitionId) => definitionId !== id);
    const viewType = VIEW_TYPES.SERVICE_DEFINITION_EDIT;
    const payload = { viewType, data: definitions };
    dispatch(addViewObject(payload));
    handleCloseDialog();
    toast.success(t("m.delete.data.success"));
  };

  return (
    <ConfirmDialog
      open={open}
      onClose={handleCloseDialog}
      promiseFunction={() => deleteServiceDefinition(id)}
      onSuccess={onSuccess}
      title={"t.email.serviceDefinition.delete.dialog"}
      message={"m.delete.service.definition.warning.message"}
    />
  );
};

export default ServiceDefinitionDeleteDialog;
